import { render, staticRenderFns } from "./PushNotificationListItem.vue?vue&type=template&id=54f023c1"
import script from "./PushNotificationListItem.vue?vue&type=script&lang=js"
export * from "./PushNotificationListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports